import { load } from '@shopify/theme-sections'
import '../sections/template-application'
import '../../styles/templates/template.application.scss'

load([ `template-application` ])
